function JoyTycoonCustomer(type_id,config,confOrg) {
    myPixiElement.container.call(this);
    this.config = {
        customer_id:0,
        slot_id:0,
        girl_id:0,
        size:220,
        icon_size:60,
        girlConfig:{
            4:{margin:[60,0]},
            5:{margin:[50,0]}
        },
        combo_part:0.3,
        combo_icon_pos:[3,-1],
        tutorial_mode:0,
        onTimerEnd:function(){},
        onCombo:function(){}
    };
    if(typeof confOrg.customersConfig[type_id] !== "undefined") {
        this.config = $.extend(true,this.config,copyObj(confOrg.customersConfig[type_id]));
    }
    
    this.config = $.extend(true,this.config,config);
    
    this.confOrg = confOrg;
    this.needObj=[];
    this.type_id = intval(type_id);



    this.storage={
        "state":"move",//move->idzie do stanowiska,need->czeka na zabawki, leave->opuszcza gre
        "busy":{mili_end:0,mili_have:0},
        "tent_id":0,
        "slot_tent_id":0,
        "wasFail":0,
        "combo":{can_give:1,was_fail:0},
        "bonus_arr":[]
    };

    this.customerImage = new myPixiElement.img({img:"customer"+this.config.girl_id,pos:[0,180]});
    if(typeof this.config.girlConfig[this.config.girl_id]!="undefined"){
        var gconf=this.config.girlConfig[this.config.girl_id];
        this.customerImage.x+=gconf.margin[0];
        this.customerImage.y+=gconf.margin[1];
    }
    this.needContainer = new myPixiElement.container();
    this.objectContainer = new myPixiElement.container();
    this.comboContainer= new myPixiElement.container();
    
    
    var smoke = new myPixiElement.img({img:"customer_smoke_big_smoke"});
    this.objectContainer.alpha = 1;
    this.needContainer.alpha = 0;
    this.needContainer.x = 140;
    this.needContainer.y = -smoke.conf.height/2+50;
    this.objectContainer.x = -4;
    this.objectContainer.y = -4;
    
    
    this.moveObj={dir:[0,0],step:0,step_max:0,pos_start:[0,0],scale_arr:[100,100]};

    

    this.needContainer.width = smoke.conf.width;
    this.needContainer.height = this.config.size;
    

    this.needContainer.addChild(smoke);
    this.needContainer.addChild(this.objectContainer);
    this.barContainer=new myPixiElement.container({});
    this.barContainer.x=47;
    this.barContainer.y=0;
  
    this.progressBar = new myPixiBar({
        texture_name:[
          "customer_smoke_big_fill0",
          "customer_smoke_big_fill1",
          "customer_smoke_big_fill2"
        ],
        anchor:[0.5,0.5],
        vertical:true,
        val:0,
        val_max:100
    },this.config.resources);
    this.barContainer.alpha=0;
    var progH=this.progressBar.conf.height;
    var comboY=(1-this.config.combo_part)*progH-progH/2;
    
    this.comboContainer.addChild(new myPixiElement.img({img:"combo_happy_box"}));
    this.happyObj=new myPixiElement.img({img:"combo_happy",pos:this.config.combo_icon_pos});
    this.comboContainer.addChild(this.happyObj);
    this.comboContainer.x=23;
    this.comboContainer.y=comboY;
    if(this.config.tutorial_mode){
        this.config.combo_part=0;
        this.comboContainer.alpha=0;
        this.config.onCombo=function(){};
    }
    
    
    
//    customer_smoke_shadow
    this.barContainer.addChild(new myPixiElement.img({img:"customer_smoke_big_timer",pos:[0,0]}));
    this.barContainer.addChild(this.progressBar);
    this.barContainer.addChild(this.comboContainer);
  
    this.addChild(this.customerImage);
    this.addChild(this.needContainer);
    this.needContainer.addChild(this.barContainer);
    this.hateImg=new myPixiElement.img({img:"customerHate",pos:[250,-230],anchor:[1,0]})
    this.hateImg.alpha=0;
    this.addChild(this.hateImg);
    this.delta_sum=0;
    
}
JoyTycoonCustomer.prototype = Object.create(myPixiElement.container.prototype);
JoyTycoonCustomer.prototype = $.extend(JoyTycoonCustomer.prototype,{
    takePosObjectCointainer:function(){
        var pos=[this.needContainer.x,this.needContainer.y];
        pos=addVector(pos,[this.objectContainer.x,this.objectContainer.y]);
        return pos;
    },
    takeGirlId:function(){
        return this.config.girl_id;
    },
    takeState:function(){
        return this.storage.state;
    },
    win:function(){
        this.clearNeed();
    },
    clearNeed:function () {
        this.needContainer.alpha = 0;
        this.needObj=[];
        this.storage.state="have";
        
    },
    setTent:function(opt){
        var conf=$.extend(true,{
            toy_id:0,
            slot_id:0,
            howlong_mili:0
        },opt);
        this.storage.tent_toy_id=conf.toy_id;
        this.storage.slot_tent_id=conf.slot_id;
        this.needContainer.alpha = 1;
        this.objectContainer.alpha=1;
        
        this.objectArr=[];
        this.objectContainer.removeChildren();
        var obj= new myPixiElement.img({img:"tent"+conf.tent_id,pos:[0,0],anchor:[0.5,0.5],scaleTo:[60,60]});
        this.objectContainer.addChild(obj);
        this.makeBusy(conf.howlong_mili);
        
        
        var confObj = {
            width:this.config.icon_size,
            height:this.config.icon_size,
            pos:[0,0],
            type:"toy",
            add_ids:[],
            background:"customer_smoke_wrap",
            anchor:[0.5,0.5]
        };
        var confOrg=this.confOrg.toysConfig[conf.toy_id];

        var objNew = new JoyTycoonObject(confObj,confOrg);
        this.objectContainer.addChild(objNew);
        
    },
    takeNeedTent:function(){
        var res={
            busyTime:this.storage.busy.mili_end-this.storage.busy.mili_have,
            customer_id:this.config.customer_id,
            tent_id:this.storage.tent_id
        };
        
        return res;
    },
    freeTentSlot:function(){
        var slot_id=this.storage.slot_tent_id;
        this.storage.slot_tent_id=0;
        this.needContainer.alpha = 0;
        return slot_id;
    },
    setNeed:function (needObjs) {
      var obj_set=[];
      var size = this.config.icon_size,i,index,item,conf,confOrg,id_str;
      var pos;
      var need_count=needObjs.length;
      var part=Math.round(this.config.size/need_count/2);
      for(i in needObjs){
          item = needObjs[i];//type,id,add_ids
          index=intval(i);
          id_str=item.type+""+item.id;
          pos=[0,part+2*i*part-this.config.size/2];
          conf = {
                width:size,
                height:size,
                pos:pos,
                type:item.type,
                add_ids:item.add_ids,
                background_arr:["customer_smoke_wrap"],
                anchor:[0.5,0.5]
          };
          if(typeof item.tutorial!="undefined"){
              conf.background_arr.push("tutorial_back");
          }
          item.pos=pos;
          item.blocked=0;
          confOrg={};
          if(item.type=="toy"){
              confOrg=this.confOrg.toysConfig[item.id];
          }
          else if(item.type=="ice"){
              confOrg=this.confOrg.iceConfig[item.id];
          }




          // console.log(item,this.confOrg.toysConfig);
          var objNew = new JoyTycoonObject(conf,confOrg);

          // this.addChild(obj);
          
          this.objectContainer.addChild(objNew);
          item.obj=objNew;
          obj_set.push(item);

      }
      this.needObj = obj_set;



      var howlong_mili=mt_rand(this.config.waitingTime.min,this.config.waitingTime.max);
      this.makeBusy(howlong_mili);
      this.needContainer.alpha = 1;
      this.objectContainer.alpha=1;

    },
    onFirstMoveEnd:function (opt) {
      //client doszedl do lady
        opt=$.extend(true,{
            tutorial_need:{}
        },opt);
        var ret={toy_ids:[],ice_ids:{}};
      
        this.config.onTimerEnd=opt.onTimerEnd;
      
        var allItems = this.config.likes;
        var howmany = intval(this.config.itemCount);
        if(this.config.customer_id<=3){
            howmany=Math.min(howmany,2);
        }
        var used={toy:[],ice:[]};
        var toChoose=[],addChoose=[],i,id,k,bum,add_id,add_key;
        var like_arr=[];
        
        var choose;
        var ice_conf,ice_count;
        for(k=0;k<howmany;k++){
            if(typeof opt.tutorial_need.type=="undefined"){
                toChoose=[];
                for(i in allItems.toy_ids){
                    id=allItems.toy_ids[i];
                    if(!in_array(id,used.toy)){
                        toChoose.push({type:"toy",id:id});
                    }
                }
                if(used.ice.length<2 && this.config.customer_id>3){
                    for(i in allItems.ice_ids){
                        id=allItems.ice_ids[i];
                        toChoose.push({type:"ice",id:id});
                    }
                }
                choose=toChoose[mt_rand(0,toChoose.length-1)];
                choose["add_ids"]=[];
                if(choose.type=="ice"){
                    ice_conf=this.confOrg.iceConfig[choose.id];
                    addChoose=[];
                    for(i in ice_conf.add_ids){
                        add_id=ice_conf.add_ids[i];
                        if(in_array(add_id,allItems.add_ids)){
                            addChoose.push(add_id)
                        }
                    }
                    if(addChoose.length){
                        ice_count=mt_rand(0,addChoose.length);
                        for(i=0;i<ice_count;i++){
                            add_key=mt_rand(0,addChoose.length-1);
                            add_id=addChoose[add_key];
                            if(!in_array(add_id, choose["add_ids"])){
                                choose["add_ids"].push(add_id);
                                addChoose.splice(add_key,1);
                            }

                        }
                    }
                }
            }
            else{
                choose=opt.tutorial_need;
                choose.tutorial=1;
                k=howmany;
            }
            choose["add_ids"].sort();
            used[choose.type].push(choose.id);
            like_arr.push(choose);
        }
        this.setNeed(like_arr);
        this.storage.state="need";
        return ret;
    },
    getTimePerc:function() {
      return Math.floor(this.busyTime/this.maxTime*100);
    },
    isNeedSame:function(need,bum){
        if(this.storage.wasFail){
            return false;
        }
        var k, add_pass;
        if(bum.type==need.type && bum.id==need.id){
            if(bum.add_ids.length==0 && need.add_ids.length==0){
                return true;
            }
            if(bum.add_ids.length==need.add_ids.length){
                add_pass=1;
                for(k in need.add_ids){
                    if(!in_array(need.add_ids[k],bum.add_ids)){
                        add_pass=0;
                    }
                }
                if(add_pass==1){
                    return true;
                }
            }
        }
        return false;
    },
    checkIfNeed:function(need){
        var i,bum;
        var res={res:0,busyTime:0,customer_id:this.config.customer_id};
        if(this.storage.busy.mili_end==0){
            return res;
        }
        if(this.privCheckIfNeedTent(need)){
            res.res=1;
            res.busyTime=this.storage.busy.mili_end-this.storage.busy.mili_have;
            return res;
        }
        for(i in this.needObj){
            bum=this.needObj[i];
            if(bum.blocked==0 && this.isNeedSame(need,bum)){
                res.res=1;
                res.busyTime=this.storage.busy.mili_end-this.storage.busy.mili_have;
                res.obj=bum;
                return res;
            }
        }
        return res;
    },
    privCheckIfNeedTent:function(need){
        if(this.needObj.length==0 && need.type=="toy" && this.storage.tent_toy_id==need.id && this.storage.wasFail==0){
            return true;
        }  
        return false;
    },
    needSomething:function(){
        var i,bum;
        for(i in this.needObj){
            if(this.needObj[i].blocked==0){
                return true;
            }
        }
        return false;
    },
    canEndNeed:function(){
        if(this.needObj.length>0){
            return false;
        }
        return true;
    },
    blockNeed:function(need){
        if(this.privCheckIfNeedTent(need)){
            //tent
            return {pos:[0,0]};
        }
        var i,bum;
        for(i in this.needObj){
            bum=this.needObj[i];
            if(bum.blocked==0 && this.isNeedSame(need,bum)){
                bum.blocked=1;
                return bum;
            }
        }
    },
    giveNeed:function(need){
        if(this.privCheckIfNeedTent(need)){
            //tent
            return {type:"tent"};
        }
        var i,bum;
        for(i in this.needObj){
            bum=this.needObj[i];
            if(bum.blocked==1 && this.isNeedSame(need,bum)){
                bum.obj.myRemove();
                this.needObj.splice(i,1);
                break;
            }
        }
        return {};
    },
    takeId:function(){
        return this.config.customer_id;
    },
    takeSize:function(){
        return [this.customerImage.conf.width,this.customerImage.conf.height];
    },
    makeBusy:function (howlong_mili) {
        
        this.barContainer.alpha=1;
        
        this.storage.busy={mili_end:howlong_mili,mili_have:0};
        this.progressBar.setBar(this.storage.busy.mili_have,this.storage.busy.mili_end);
        return true;
    },
    storeBonus:function(){
        var perc=Math.round((this.storage.busy.mili_end-this.storage.busy.mili_have)*100/this.storage.busy.mili_end);
        this.storage.bonus_arr.push(perc);
    },
    takeBonus:function(){
        var i,sum=0;
        for(i in this.storage.bonus_arr){
            sum+=this.storage.bonus_arr[i];
        }
        var perc=Math.round(sum/this.storage.bonus_arr.length/2)+50;
        return perc;
    },
    releaseItem:function(){
        this.storeBonus();
        
        this.storage.busy.mili_have=0;//{mili_end:0,mili_have:0};
        this.progressBar.updateTexture(0);
        if(this.storage.state=="need"){
            if(!this.tryGiveCombo()){
                this.comboContainer.alpha=0;
                this.storage.combo.can_give=0;
            }
        }
        if(!this.storage.combo.was_fail || 1==1){
            this.comboContainer.fadeStop();
            this.comboContainer.alpha=1;
            this.storage.combo.can_give=1;
        }
    },
    releaseBusy:function(){
        this.storeBonus();
        
        if(this.storage.state=="need"){
            if(!this.tryGiveCombo()){
                this.comboContainer.alpha=0;
                this.storage.combo.can_give=0;
            }
        }
        
        
        this.storage.busy={mili_end:0,mili_have:0};
        this.barContainer.alpha=0;
    },
    lose:function(){
        this.clearNeed();
        this.storage.state="lose";
    },
   
    remove:function(){
        
    },
    wasFail:function(){
       return this.storage.wasFail;
    },
    moveToPos:function(opt,onEnd){
        var conf=$.extend(true,{
            pos_end:[0,0],
            scale_arr:[100,100],
            v:10,
            hate:0
        },opt);
        var pos_start=[this.x,this.y];
        var dir=makeVector(pos_start,conf.pos_end);
        var step_max=lengthVector(dir)/conf.v;
        if(conf.hate){
            this.hateImg.alpha=1;
        }
        this.moveObj=$.extend(true,this.moveObj,{
            dir:dir,
            step:0,
            scale_arr:conf.scale_arr,
            step_max:step_max,
            pos_start:pos_start,
            onEnd:onEnd
        });
    },
    update:function (delta) {
        this.myUpdate(delta);
        this.updateTime(delta);
        this.updateMove(delta);
    },
    updateMove:function(delta){
        if(this.moveObj.step_max!=0){
            this.moveObj.step+=delta;
            var div=1;
            if(this.moveObj.step>=this.moveObj.step_max){
                this.moveObj.step=this.moveObj.step_max;
                this.moveObj.step_max=0;
            }
            else{
                div=this.moveObj.step/this.moveObj.step_max;
            }
            this.x=this.moveObj.dir[0]*div+this.moveObj.pos_start[0];
            this.y=this.moveObj.dir[1]*div+this.moveObj.pos_start[1];
            if(this.moveObj.scale_arr[0]!=this.moveObj.scale_arr[1]){
                var scale_int=this.scale_arr[0]+(this.scale_arr[1]-this.scale_arr[0])*div;
                this.scale.set(scale_int/100,scale_int/100);
            }
            
            
            if(this.moveObj.step_max==0){
                if(typeof this.moveObj.onEnd!="undefined"){
                    this.moveObj.onEnd.call(this);
                }
            }
        }
    },
    tryGiveCombo:function(){
        if(this.storage.combo.can_give==0 || this.storage.busy.mili_end==0 && this.storage.busy.mili_have>=this.storage.busy.mili_end*(1-this.config.combo_part)){
            return false;
        }
        var offset=this.happyObj.toGlobal(new PIXI.Point(0,0));
        this.storage.combo.can_give=0;
        this.comboContainer.fadeOut(15);
        var pos_combo=[offset.x,offset.y];
        this.config.onCombo.call(this,pos_combo);
        return true;
    },
    updateTime:function (delta) {
        
        if(this.storage.busy.mili_end==0){
            return false;
        }
        this.storage.busy.mili_have+=delta*1000/60;
        this.progressBar.updateVal(this.storage.busy.mili_end-this.storage.busy.mili_have);
        this.comboContainer.myUpdate(delta);
//        $.qLog(this.storage.busy.mili_have+"_"+this.storage.busy.mili_end*(1-this.config.combo_part)+"<br>")
        if(this.storage.combo.can_give==1 && this.storage.busy.mili_have>=this.storage.busy.mili_end*(1-this.config.combo_part)){
            this.storage.combo.can_give=0;
            this.storage.combo.was_fail=1;
            this.comboContainer.fadeOut(15);
        }
        
        
        if(this.storage.busy.mili_have>=this.storage.busy.mili_end){
            this.storage.busy.mili_end=0;
            this.storage.wasFail=1;
            this.config.onTimerEnd.call(this);
            
        }
        
      },
});